import * as React from "react";

const MagnifyingGlassOutlineRegularIcon = ({ color = "#1F1F1F", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    {...props}
  >
    <path
      d="M10.764 10.2343L8.41692 7.88774C9.09719 7.07104 9.4364 6.02352 9.364 4.96309C9.2916 3.90265 8.81316 2.91096 8.02821 2.19429C7.24326 1.47763 6.21222 1.09118 5.1496 1.11533C4.08697 1.13948 3.07456 1.57237 2.32298 2.32395C1.57139 3.07554 1.1385 4.08795 1.11435 5.15057C1.0902 6.2132 1.47665 7.24423 2.19332 8.02919C2.90998 8.81414 3.90168 9.29258 4.96211 9.36498C6.02254 9.43738 7.07007 9.09816 7.88677 8.4179L10.2333 10.7649C10.2682 10.7998 10.3095 10.8274 10.3551 10.8463C10.4006 10.8651 10.4494 10.8748 10.4986 10.8748C10.5479 10.8748 10.5967 10.8651 10.6422 10.8463C10.6878 10.8274 10.7291 10.7998 10.764 10.7649C10.7988 10.7301 10.8264 10.6887 10.8453 10.6432C10.8641 10.5977 10.8739 10.5489 10.8739 10.4996C10.8739 10.4503 10.8641 10.4016 10.8453 10.356C10.8264 10.3105 10.7988 10.2691 10.764 10.2343ZM1.87364 5.24962C1.87364 4.58211 2.07158 3.92958 2.44243 3.37457C2.81328 2.81955 3.34038 2.38697 3.95709 2.13153C4.57379 1.87608 5.25239 1.80924 5.90707 1.93947C6.56176 2.06969 7.16312 2.39113 7.63513 2.86313C8.10713 3.33514 8.42857 3.9365 8.55879 4.59119C8.68902 5.24587 8.62218 5.92447 8.36674 6.54117C8.11129 7.15788 7.67871 7.68498 7.12369 8.05583C6.56868 8.42668 5.91615 8.62462 5.24864 8.62462C4.35384 8.62363 3.49597 8.26773 2.86325 7.63501C2.23053 7.00229 1.87463 6.14442 1.87364 5.24962Z"
      fill={color}
      style={{
        fill: { color },
        fillOpacity: 1
      }}
    />
  </svg>
);
export default MagnifyingGlassOutlineRegularIcon;
